module.exports = __webpack_public_path__ + "static/media/plus-circle.1d4e9997.svg";